import { render, staticRenderFns } from "./EventContainer.vue?vue&type=template&id=564e52af&scoped=true"
import script from "./EventContainer.vue?vue&type=script&lang=js"
export * from "./EventContainer.vue?vue&type=script&lang=js"
import style0 from "./EventContainer.vue?vue&type=style&index=0&id=564e52af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e52af",
  null
  
)

export default component.exports